import { useParams } from "react-router-dom";
import { useLists } from "../../contexts/ListsContext";
import { useEffect, useState } from "react";
import { getInfluencersByListId, removeInfluencerFromList } from "../../api/instagram";
import Lookalikes from "../discovery/Lookalikes";
import toast from "react-hot-toast";

const ListDetail = () => {
  const { id } = useParams();
  const { lists } = useLists();
  const list = lists.find(item => item._id === id);
  const [lookalikes, setLookalikes] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchInfluencers = async () => {
      try {
        const response = await getInfluencersByListId({
          id,
          data: { page },
        });

        setLookalikes(response.influencers);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error(error);
        toast.error(error?.response?.data?.message || error.message);
      }
    }

    fetchInfluencers();
  }, [id, page]);

  const handleRemove = async (lookalike) => {
    try {
      await removeInfluencerFromList({
        userId: lookalike.userId,
        listId: list._id,
      });

      setLookalikes(prevLookalikes =>
        prevLookalikes.map(item =>
          item.userId === lookalike.userId ? { ...item, deleted: true } : item
        )
      );

      toast.success(`@${lookalike.profile.username} successfully removed from the list`);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message);
    }
  }

  return (
    <>
      <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">{list?.name}</h1>
      </div>
      <Lookalikes
        lookalikes={lookalikes}
        page={page}
        totalPages={totalPages}
        onPageChange={(value) => setPage(value)}
        removeOption={true}
        handleRemove={handleRemove}
      />
    </>
  )
}

export default ListDetail;